/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LpBookEntry } from './lpBookEntry';

export interface HistoricalBookDto {
  timestamp: string;
  bids: Array<LpBookEntry>;
  asks: Array<LpBookEntry>;
}
